export const SET_TSE_CONFIG = 'SET_TSE_CONFIG'
export const SET_TSE_NOTIFICATION = 'SET_TSE_NOTIFICATION'
export const UPDATE_TSE_DISABLE_NOTIFICATION = 'UPDATE_TSE_DISABLE_NOTIFICATION'
export const SET_TSE_FON_DATA = 'SET_TSE_FON_DATA'
export const SET_TSE_FON_ERROR = 'SET_TSE_FON_ERROR'
export const SET_TSE_NULL_ORDERS = 'SET_TSE_NULL_ORDERS'
export const SET_IS_PROCESSING_PRINT_YEAR_ORDER = 'SET_IS_PROCESSING_PRINT_YEAR_ORDER'
